"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryListExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/query-list/examples/default.ts';
var countryQueryList = _1.QueryList.ofType();
var QueryListExample = /** @class */ (function () {
    function QueryListExample() {
        var _this = this;
        this.checkmark = true;
        this.filterable = true;
        this.initialContent = false;
        this.disableArrowKeys = false;
        this.renderItem = function (item, index) {
            return (0, mithril_1.default)(_1.ListItem, {
                label: item.name,
                selected: _this.selectedItem === item,
                disabled: index === 3 || index === 4,
                key: item.code
            });
        };
        this.handleSelect = function (item) {
            _this.selectedItem = item;
        };
    }
    QueryListExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(countryQueryList, {
                disableArrowKeys: this.disableArrowKeys,
                checkmark: this.checkmark,
                initialContent: this.initialContent ? 'Search...' : undefined,
                items: examples_1.countries,
                itemPredicate: this.itemPredicate,
                itemRender: this.renderItem,
                inputAttrs: {
                    contentLeft: (0, mithril_1.default)(_1.Icon, { name: _1.Icons.SEARCH }),
                    placeholder: 'Search countries...'
                },
                filterable: this.filterable,
                onSelect: this.handleSelect,
                listAttrs: {
                    style: 'height:300px; width:300px',
                    size: this.size
                }
            })
        ]);
    };
    QueryListExample.prototype.itemPredicate = function (query, item) {
        return item.name.toLowerCase().includes(query.toLowerCase());
    };
    QueryListExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.filterable,
                label: 'Filterable',
                onchange: function () { return _this.filterable = !_this.filterable; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.checkmark,
                label: 'Item checkmark',
                onchange: function () { return _this.checkmark = !_this.checkmark; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.initialContent,
                label: 'Has initial content',
                onchange: function () { return _this.initialContent = !_this.initialContent; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.disableArrowKeys,
                label: 'Disable arrow keys',
                onchange: function () { return _this.disableArrowKeys = !_this.disableArrowKeys; }
            })
        ];
    };
    return QueryListExample;
}());
exports.QueryListExample = QueryListExample;
